import { usePromisedRequest as promiseRequest } from "../Common/request";
import { resolveNoContent } from "./Utils/utils";

export default {
    setStatusForMat(eventId: number, matId: number, fightId: number, status) {
        if (matId === 0) {
            return Promise.resolve();
        }

        return promiseRequest({
            url: `/api/admin/events/${eventId}/fight-queue-statuses/${matId}`,
            method: "put",
            json: {
                eventId: eventId,
                matId: matId,
                fightId: fightId,
                status: status,
            },
        }).then(resolveNoContent());
    },
    removeStatusForMat(eventId: number, matId: number): Promise<void> {
        if (matId === 0) {
            return Promise.resolve();
        }

        return promiseRequest({
            url: `/api/admin/events/${eventId}/fight-queue-statuses/${matId}`,
            method: "delete",
            json: true,
        }).then(resolveNoContent());
    },
};
